import type { NavigationGuard } from 'vue-router'
import useDeveloperStore from '@/stores/developerStore'
import { CertificationStatus, IsSubAccountConst } from '@/constant'

/** 未登录状态下可访问本项目中的白名单页面  */
const whitelistPageSet = new Set(['home', 'document', 'contact', 'serviceAgreement', 'searchTableDemo'])
/** 别的项目的路由页列表 */
const otherProjectRoutes = ['/web/geneOperation/refresh']

const noticeRegExp = /^\/notice(\/\d+)?$/
const accountPowerCanVisitPageMap: Record<number, RegExp> = {
  0: /^\/controlCenter\/accountManagement(\/\w+)?$/,
  1: /^\/controlCenter\/gameManagement(\/.*)?$/,
  2: /^\/controlCenter\/dataCenter\/mobileGame$/,
  3: /^\/controlCenter\/dataCenter\/h5$/,
  4: /^\/controlCenter\/settlementCenter(\/\w+)?$/
}

/**
 * 根据权限可访问的路由范围
 */
const routeCanVisit = (accountPower: number[], path: string) => {
  const _accountPower = [0, ...accountPower] // 0是子账号的账号管理权限
  const map = _accountPower.reduce(
    (acc, cur) => {
      acc[cur] = accountPowerCanVisitPageMap[cur]
      return acc
    },
    {} as Record<number, RegExp>
  )
  return Object.values(map).some((reg) => reg.test(path))
}

/**
 * 子账号路由访问处理
 */
const handleSubAccountVisit = (toPath: string, accountPowerList: number[]) => {
  switch (true) {
    case toPath === '/controlCenter/accountManagement/accountInfo': {
      return { path: '/controlCenter/accountManagement/subAccountInfo' }
    }
    case [
      '/controlCenter/accountManagement/subAccountManagement',
      '/controlCenter/accountManagement/authenticationInfo',
      '/controlCenter/accountManagement/ipWhitelist'
    ].includes(toPath): {
      return { name: 'home', replace: true }
    }
    default: {
      return routeCanVisit(accountPowerList, toPath) ? true : { name: 'home', replace: true }
    }
  }
}

/**
 * 登录守卫
 */
const loginGuard: NavigationGuard = async (to, from) => {
  const developerStore = useDeveloperStore()
  const accountPower = developerStore.accountPower
  console.log('登录守卫----', to, from)
  // 如果访问的都是白名单页面，直接放行
  if (
    whitelistPageSet.has(to.name as string) ||
    otherProjectRoutes.includes(to.path as string) ||
    noticeRegExp.test(to.path)
  )
    return true
  // 否则，需要判断是否登录
  if (!developerStore.isLoggedIn) return { name: 'home' }
  // 汇率中心
  // if (to.path === '/controlCenter/exchangeRateRecord' && window.isInternational) {
  //   return true
  // }
  // 处理子账号的路由访问
  if (developerStore.isSubDeveloper === IsSubAccountConst.True) {
    return handleSubAccountVisit(to.path, accountPower)
  }
  // 处理主账号的路由访问
  if (developerStore.isSubDeveloper === IsSubAccountConst.False) {
    switch (true) {
      case [CertificationStatus.NotCertified, CertificationStatus.AuditFailed].includes(
        developerStore.examineAllState
      ): {
        if (to.path === '/controlCenter/gameManagement/gameManagementMainEntance') {
          return true
        } else if (
          to.path === '/controlCenter/certification' ||
          to.path === '/controlCenter/gameManagement/gameReview'
        ) {
          return true
        } else if (
          to.path === '/controlCenter/accountManagement/certificationReview' &&
          from.path === '/controlCenter/certification'
        ) {
          await developerStore.getLatestCertificationStatus()
          return
        } else {
          return { name: 'certification', replace: true }
        }
      }
      case developerStore.examineAllState === CertificationStatus.Auditing: {
        // if (
        //   to.path === '/controlCenter/accountManagement/certification' &&
        //   from.path !== '/controlCenter/accountManagement/certificationReview'
        // ) {
        //   // 说明不是从审核中页面跳转过来的，此时需要重新获取审核状态
        //   await developerStore.getLatestCertificationStatus()
        //   return true
        if (to.path === '/controlCenter/gameManagement/gameManagementMainEntance') {
          return true
        } else if (
          to.path === '/controlCenter/certification' ||
          to.path === '/controlCenter/accountManagement/certificationReview'
        ) {
          return true
        } else if (to.path === '/controlCenter/gameManagement/gameReview') {
          return true
        } else if (
          to.path === '/controlCenter/accountManagement/certification' &&
          from.path === '/controlCenter/accountManagement/certification'
        ) {
          return true
        } else {
          return { name: 'certificationReview', replace: true }
        }
      }
      case developerStore.examineAllState === CertificationStatus.AuditSuccess: {
        if (
          to.path === '/controlCenter/accountManagement/certificationReview' ||
          to.path === '/controlCenter/certification'
        ) {
          return { name: 'authenticationInfo', replace: true }
        } else if (to.path === '/controlCenter/accountManagement/subAccountInfo') {
          return { name: 'accountInfo', replace: true }
        }
        console.log('routeCanVisit(accountPower, to.path)', routeCanVisit(accountPower, to.path))
        return routeCanVisit(accountPower, to.path) ? true : { name: 'home', replace: true }
      }
    }
  }
}
export default loginGuard
